import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class DashboardAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);
		// Entidade principal
		this.__entity = 'dashboard';
	}
	/**
	 * get_dashboard_leads_chart
	 *
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  02/2020
	 * @return object Promise
	 */
	public get_dashboard_leads_chart(day?) {
		return this._call(this.__entity + '/get_dashboard_leads_chart/',{days:30},'get');
	}
		/**
	 * get_dashboard_chart_data
	 *
	 * busca lista de processos
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  09/2019
	 * @return object Promise
	 */
	public get_dashboard_numbers(day?) {
		return this._call(this.__entity + '/get_dashboard_numbers/', { days: day }, 'get');
	}
	/**
 * download_report
 *
 * Relatorio de todos os campos do sistema
 *
 * @access public
 * @author Nicolas Aoki
 * @since  09/2019
 * @return object Promise
 */
	public download_report(day?, calendar?) {

		if (!calendar) {
			return this.getBlob(this.__entity + '/download_resource/', { days: day });
		} else {
			return this.getBlob(this.__entity + '/download_resource/', { calendar: calendar });
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/dashboard.api.ts